module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dailydetail w98"
  }, [_c('div', {
    staticClass: "crumbs"
  }, [_c('span', [_vm._v("首页")]), _vm._v(">\n    "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/DailyMeeting"
    }
  }, [_vm._v("每日读片")]), _vm._v(" >")], 1), _vm._v(" "), _c('span', [_vm._v("读片详情")])]), _vm._v(" "), _c('div', {
    staticClass: "daily-title"
  }, [_c('div', {
    staticClass: "bigtit"
  }, [_vm._v(_vm._s(_vm.events.title) + " ")]), _vm._v(" "), _c('el-tag', [_vm._v(_vm._s(_vm.events.confType))]), _vm._v(" "), _c('span', {
    staticClass: "meet-times"
  }, [_vm._v(_vm._s(_vm.events.startTime + ' ~ ' + _vm.events.endTime))]), _vm._v(" "), _c('el-button', {
    staticClass: "open-vedio",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.startConfView
    }
  }, [_vm._v(_vm._s(_vm.btnText))]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "members fr"
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.memberCount,
      "max": 99
    }
  }, [_vm._v("\n          参会人员\n          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.attendList), function(item, index) {
    return _c('el-dropdown-item', {
      key: index,
      attrs: {
        "disabled": ""
      }
    }, [_vm._v(_vm._s(item.docName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "layout-left"
  }, [_c('tabs', {
    staticClass: "mytab",
    attrs: {
      "activeName": '0'
    },
    on: {
      "tabChange": _vm.tabChange
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "0"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("附件(" + _vm._s(_vm.attachList.length) + ")")]), _vm._v(" "), _c('el-collapse', {
    staticClass: "files",
    model: {
      value: (_vm.collapseActive),
      callback: function($$v) {
        _vm.collapseActive = $$v
      },
      expression: "collapseActive"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "0"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('label', [_vm._v("文档类型")]), _vm._v(" "), _c('a', {
    staticClass: "add-btn",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("从我的电脑选择\n                          "), _c('input', {
    attrs: {
      "type": "file",
      "picType": "ppt/*,pptx/*,pdf/*,doc/*,docx/*,rtf/*,xls/*",
      "multiple": "multiple",
      "accept": _vm.fileType
    },
    on: {
      "change": function($event) {
        return _vm.changeFn($event, 1)
      },
      "click": function($event) {
        return _vm.addFile('1')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "file-list query_medicalRecord_left_file_content"
  }, _vm._l((_vm.fileannex), function(fj, index) {
    return _c('p', {
      key: index,
      class: {
        check: index == _vm.fileI
      },
      attrs: {
        "title": fj.label
      },
      on: {
        "click": function($event) {
          return _vm.fileCLick('file', fj, index)
        }
      }
    }, [_vm._v(_vm._s(fj.label))])
  }), 0)], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('label', [_vm._v("图片类型")]), _vm._v(" "), _c('a', {
    staticClass: "add-btn",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("从我的电脑选择 "), _c('input', {
    attrs: {
      "type": "file",
      "fileType": "image/*",
      "multiple": "multiple",
      "accept": _vm.picType
    },
    on: {
      "change": function($event) {
        return _vm.changeFn($event, 2)
      },
      "click": function($event) {
        return _vm.addFile('2')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "file-list query_medicalRecord_left_file_content"
  }, _vm._l((_vm.picannex), function(fj, index) {
    return _c('p', {
      key: index,
      class: {
        check: index == _vm.picI
      },
      attrs: {
        "title": fj.label
      },
      on: {
        "click": function($event) {
          return _vm.fileCLick('img', fj, index)
        }
      }
    }, [_vm._v(_vm._s(fj.label))])
  }), 0)], 2)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "1"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("影像(" + _vm._s(_vm.studyList.length) + ")")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px",
      "padding-top": "10px"
    }
  }, [_c('radius-input', {
    attrs: {
      "markedwords": _vm.videomarkedwords
    },
    on: {
      "searchClick": _vm.videosearchClick,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.videosearchClick($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "currentList"
  }, [_c('reportTable', {
    staticClass: "img-table",
    attrs: {
      "data": _vm.data1,
      "head": _vm.head,
      "height": _vm.tH1
    },
    on: {
      "showDetial": _vm.showDetials
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "historyList"
  }, [_c('h2', [_vm._v("| 历史检查")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "calc(100% - 40px)"
    }
  }, [_c('reportTable', {
    attrs: {
      "data": _vm.data2,
      "head": _vm.historyhead,
      "readImageList": _vm.readImageList,
      "showCheck": _vm.showCheck,
      "height": _vm.tH2
    },
    on: {
      "showDetial": _vm.hisshowDetials,
      "readImg": _vm.readImgs
    }
  })], 1)])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "2"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("病例(" + _vm._s(_vm.caseList.length) + ")")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px",
      "padding-top": "10px"
    }
  }, [_c('radius-input', {
    attrs: {
      "markedwords": _vm.casemarkedwords
    },
    on: {
      "searchClick": _vm._openMedical,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm._openMedical($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "medicalList"
  }, [_c('reportTable', {
    attrs: {
      "head": _vm.medicalhead,
      "data": _vm.data3
    },
    on: {
      "showDetial": _vm.CaseshowDetials
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-right"
  }, [(_vm.activeName === '1') ? _c('div', {
    staticClass: "reportContent"
  }, [_c('div', {
    ref: "curReport",
    staticClass: "cur-report"
  }, [_c('h2', [_vm._v(_vm._s(_vm.ExamTypeName)), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "blod"
    }
  }, [_vm._v("报告单")]), _vm._v(" "), _c('div', {
    staticClass: "report-btn"
  }, _vm._l((_vm.btnTxts), function(btnTxt, index) {
    return _c('a', {
      class: {
        hui: index == 1 || index == 0
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.prepareAycan(btnTxt)
        }
      }
    }, [_vm._v(_vm._s(btnTxt))])
  }), 0)]), _vm._v(" "), _c('reports', {
    staticClass: "report",
    attrs: {
      "info": _vm.report
    }
  })], 1), _vm._v(" "), _c('vue-scrollbar', {
    ref: "Scrollbar",
    staticClass: "checkDetails"
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "report-btn t10"
  }), _vm._v(" "), _c('div', {
    staticClass: "result-con"
  }, [_c('div', {
    staticClass: "Image"
  }, [_c('span', [_vm._v("| 影像所见")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentRow != null),
      expression: "currentRow!=null"
    }],
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.currentRow.reportEvidences))])]), _vm._v(" "), _c('div', {
    staticClass: "Result"
  }, [_c('span', [_vm._v("| 诊断结果")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentRow != null),
      expression: "currentRow!=null"
    }],
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.currentRow.reportConclusion))])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.activeName === '2') ? _c('div', [_c('tabs', {
    staticClass: "right-tab",
    attrs: {
      "activeName": '0'
    },
    on: {
      "tabChange": _vm.MTabChange
    }
  }, _vm._l((_vm.rightTabs), function(tab) {
    return _c('el-tab-pane', {
      key: tab.name,
      staticStyle: {
        "height": "100%"
      },
      attrs: {
        "label": tab.label,
        "name": tab.name
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rightTabActive === '0'),
        expression: "rightTabActive === '0'"
      }],
      staticClass: "blk"
    }, [_c('medicalNewsDetail', {
      attrs: {
        "detailList": _vm.Casereport
      }
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rightTabActive === '1'),
        expression: "rightTabActive === '1'"
      }],
      staticClass: "blk"
    }, [_c('p-table', {
      attrs: {
        "head": _vm.studyhead,
        "data": _vm.data4,
        "autoheight": 395,
        "operation": _vm.operation
      },
      on: {
        "_operation": _vm._operation_
      }
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rightTabActive === '2'),
        expression: "rightTabActive === '2'"
      }],
      staticClass: "blk"
    }, [_c('uploadDetail', {
      attrs: {
        "updateFileList": _vm.updateFileList,
        "updatePicList": _vm.updatePicList
      }
    })], 1)])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeName === '0') ? _c('div', {
    staticClass: "file_area",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayImg),
      expression: "displayImg"
    }]
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/image/defaultpic.png"),
      "alt": "",
      "height": "140"
    }
  })]), _vm._v(" "), (_vm.imgShow == '1') ? _c('div', {
    staticClass: "img_area"
  }, [_c('img', {
    attrs: {
      "width": "80%",
      "src": _vm.fileUrl,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.imgShow == '0') ? _c('div', {
    staticClass: "file_show"
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("暂不支持预览，请点击下载")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.fileUrl
    }
  }, [_vm._v("下载")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.pop1) ? _c('pops', {
    class: 'mrDialog',
    attrs: {
      "show": _vm.pop1,
      "width": '980px',
      "title": '从本院影像中选择'
    },
    on: {
      "closePop": _vm.closePop
    }
  }, [_c('pImage', {
    attrs: {
      "text": '加入读片队列',
      "videosearchVal": _vm.videosearchVal
    },
    on: {
      "_popshow": _vm.popshow,
      "_popClose": _vm.popClose
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.pop2) ? _c('pops', {
    class: 'mrDialog',
    attrs: {
      "show": _vm.pop2,
      "width": '980px',
      "title": '从病例库中选择'
    },
    on: {
      "closePop": _vm.closePop
    }
  }, [_c('div', {
    staticClass: "popScore popCourse queryCourse daily-pop2"
  }, [_c('div', {
    staticClass: "popContent clearfix"
  }, [_c('div', {
    staticClass: "leftCont medicalRecord_left"
  }, [_c('div', {
    staticClass: "margin10_box medicalRecord_left"
  }, [_c('collapse-medical-record', {
    attrs: {
      "tabs": _vm.mtabs,
      "personList": _vm.personList,
      "treeData": _vm.treeData,
      "titleList": _vm.titleList,
      "filterText": _vm.filterText
    },
    on: {
      "tabChange": _vm.pubTabChange,
      "changeColl": _vm.changeColl,
      "delPerson": _vm.delPerson,
      "addPersonList": _vm.addPersonList,
      "personClick": _vm.personClick,
      "searchClick": _vm.searchClick,
      "treeNodeClick": _vm.treeNodeClick
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rightCont"
  }, [_c('div', {
    staticClass: "rightTitle"
  }, [_c('span', {
    staticClass: "alreadyChoose"
  }, [_vm._v("当前您已选择"), _c('i', {
    staticClass: "difColor"
  }, [_vm._v(_vm._s(_vm.CaseNum))]), _vm._v("条病例")]), _vm._v(" "), _c('div', {
    staticClass: "searchbar"
  }, [_c('radiusmedical-input', {
    on: {
      "searchmediclClick": _vm.tableCaseList
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "borderCont"
  }, [_c('zTable', {
    ref: "getSelection",
    attrs: {
      "head": _vm.personTableHead,
      "data": _vm.tableData,
      "height": 300
    },
    on: {
      "tableVal": _vm.submitSelection,
      "ValLength": _vm.ValLength
    }
  }), _vm._v(" "), _c('page', {
    attrs: {
      "total": _vm.page.total,
      "currentPage": _vm.page.currentPage
    },
    on: {
      "current-page": _vm.__currentPage
    }
  })], 1)])]), _vm._v(" "), _c('btns', {
    attrs: {
      "isAllowedClick": _vm.isAllowedClick,
      "text": '加入读片队列'
    },
    on: {
      "clickbtn": _vm.Caseclickbtn
    }
  }), _vm._v(" "), _c('fullscreen', {
    attrs: {
      "loadingText": _vm.loadingText,
      "isFullscreen": _vm.isFullscreen
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('pops', {
    class: 'mrDialog',
    attrs: {
      "show": _vm.pop3,
      "width": '720px',
      "title": '上传其他附件'
    },
    on: {
      "closePop": _vm.closePop
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileBool),
      expression: "fileBool"
    }],
    staticClass: "piclist"
  }, _vm._l((_vm.FileList), function(file, index) {
    return _c('li', {
      key: index,
      on: {
        "click": _vm.finshed
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (true),
        expression: "true"
      }]
    }, [_c('i', {
      staticClass: "el-icon-circle-close",
      on: {
        "click": function($event) {
          return _vm.removeFile(index, 1)
        }
      }
    }), _vm._v(" "), _c('a', {
      staticStyle: {
        "display": "inline-block",
        "width": "100px",
        "height": "100px",
        "border": "1px solid #dbdbdb"
      }
    }, [_c('img', {
      attrs: {
        "src": file.url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(file.attach_name))])]), _vm._v(" "), _c('ProgressBar', {
      attrs: {
        "step": _vm.steps,
        "initVal": _vm.initVal,
        "stopVal": _vm.stopVal,
        "isOk": _vm.isOk
      },
      on: {
        "callback": _vm.show
      }
    })], 1)
  }), 0), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.picBool),
      expression: "picBool"
    }],
    staticClass: "piclist"
  }, _vm._l((_vm.PicList), function(file, index) {
    return _c('li', {
      key: index,
      on: {
        "click": _vm.finshed
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (true),
        expression: "true"
      }]
    }, [_c('i', {
      staticClass: "el-icon-circle-close",
      on: {
        "click": function($event) {
          return _vm.removeFile(index, 2)
        }
      }
    }), _vm._v(" "), _c('a', [_c('img', {
      attrs: {
        "src": file.url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(file.attach_name))])]), _vm._v(" "), _c('ProgressBar', {
      attrs: {
        "step": _vm.steps,
        "initVal": _vm.initVal,
        "stopVal": _vm.stopVal,
        "isOk": _vm.isOk
      },
      on: {
        "callback": _vm.show
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('btns', {
    attrs: {
      "isAllowedClick": _vm.isAllowedClick,
      "text": '加入读片队列'
    },
    on: {
      "clickbtn": _vm._clickbtn
    }
  })], 1), _vm._v(" "), _c('pops', {
    staticClass: "collect",
    attrs: {
      "show": _vm.pop4,
      "width": _vm.popwidth,
      "title": _vm.title,
      "classes": 'Collections'
    },
    on: {
      "closePop": _vm.closePop
    }
  }, [_c('elcRep', {
    attrs: {
      "elcRep": _vm.elcRep
    }
  })], 1), _vm._v(" "), _c('aycanImages', {
    ref: "aycanImages",
    attrs: {
      "hospitalId": _vm.params_image.hospitalId,
      "studyPk": _vm.params_image.studyPk,
      "studyUid": _vm.params_image.studyUid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-b36c6e1a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/dailyMeeting/dailyDetail.vue
// module id = 598
// module chunks = 1 2 3 4 5 6 7 8